<template>
    <el-dialog
        title="随机组卷"
        :visible.sync="visible"
        width="11rem"
        class="step-audit-dialog"
        key="exam3Dialog"
        :before-close="handleExam2DialogClose">
        <div class="training-step-table" style="padding: .2rem;">
            <score-category-table :questionItems="randomQuestionData"></score-category-table>
            <el-row :gutter="20">
            <el-col :span="8">
                <el-card class="box-card">
                <el-tree
                    ref="tree"
                    show-checkbox
                    @node-click="handleNodeClick"
                    @check-change="handleTreeChange"
                    :data="regions"
                    :props="props"
                    node-key="id"
                    :highlight-current="true"
                    :expand-on-click-node="false"
                    :default-expanded-keys="defaultExpandedKeys">
                </el-tree>
                </el-card>
            </el-col>
            <el-col :span="16" v-show="randomOptions.id">
                <el-card class="box-card" v-if="!randomOptions.radioNum && !randomOptions.multiNum && !randomOptions.answerNum" style="text-align:center;">
                当前试题目录下, 没有任何类型的试题
                </el-card>
                <el-card class="box-card mb20" :body-style="{ 'padding-bottom': '0px' }" v-if="randomOptions.radioNum">
                <div class="random__topic--items">
                    <div class="label mb20">单选题(共{{ randomOptions.radioNum }}题)</div>
                    <div class="content">
                    <el-form :inline="true">
                        <el-form-item label="数量">
                        <el-input-number v-model="randomOptions.singleNumber" :min="0" :max="randomOptions.radioNum" label="请输入" @change="handleTreeChange"></el-input-number>
                        </el-form-item>
                        <el-form-item label="每题分数">
                        <el-input-number v-model="randomOptions.singleScore" :min="0" :max="100" :precision="1" label="请输入" @change="handleTreeChange"></el-input-number>
                        </el-form-item>
                        <el-form-item label="总分">{{ randomOptions.singleNumber * randomOptions.singleScore }}</el-form-item>
                    </el-form>
                    </div>
                </div>
                </el-card>
                <el-card class="box-card mb20" :body-style="{ 'padding-bottom': '0px' }" v-if="randomOptions.multiNum">
                <div class="random__topic--items">
                    <div class="label mb20">多选题(共{{ randomOptions.multiNum }}题)</div>
                    <div class="content">
                    <el-form :inline="true">
                        <el-form-item label="数量">
                        <el-input-number v-model="randomOptions.muitibleNumber" :min="0" :max="randomOptions.multiNum" label="请输入" @change="handleTreeChange"></el-input-number>
                        </el-form-item>
                        <el-form-item label="每题分数">
                        <el-input-number v-model="randomOptions.muitibleScore" :min="0" :max="100" :precision="1" label="请输入" @change="handleTreeChange"></el-input-number>
                        </el-form-item>
                        <el-form-item label="总分">{{ randomOptions.muitibleNumber * randomOptions.muitibleScore }}</el-form-item>
                    </el-form>
                    </div>
                </div>
                </el-card>
                <el-card class="box-card mb20" :body-style="{ 'padding-bottom': '0px' }" v-if="randomOptions.answerNum">
                <div class="random__topic--items">
                    <div class="label mb20">问答题(共{{ randomOptions.answerNum }}题)</div>
                    <div class="content">
                    <el-form :inline="true">
                        <el-form-item label="数量">
                        <el-input-number v-model="randomOptions.answerNumber" :min="0" :max="randomOptions.answerNum" label="请输入" @change="handleTreeChange"></el-input-number>
                        </el-form-item>
                        <el-form-item label="每题分数">
                        <el-input-number v-model="randomOptions.answerScore" :min="0" :max="100" :precision="1" label="请输入" @change="handleTreeChange"></el-input-number>
                        </el-form-item>
                        <el-form-item label="总分">{{ randomOptions.answerNumber * randomOptions.answerScore }}</el-form-item>
                    </el-form>
                    </div>
                </div>
                </el-card>
            </el-col>
            </el-row>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleExam2DialogClose">取消</el-button>
            <el-button type="primary" size="mini" @click="handleRandomDialogSubmit">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import pagination from '@/components/pagination/index'
import scoreCategoryTable from './scoreCategoryTable'

export default {
    name: 'chooseRandomPaperDailog',
    props: ['visible'],
    components: { pagination, scoreCategoryTable },
    data() {
        return {
            defaultExpandedKeys: [0],
            regions: [],
            props: {
                label: 'name',
                children: 'childrenList',
                isLeaf: 'childNum'
            },
            randomOptions: {
                singleNumber: 0,
                singleScore: 0,
                muitibleNumber: 0,
                muitibleScore: 0,
                answerNumber: 0,
                answerScore: 0
            },
            randomQuestionData: [],
            configIds: [],
            examPaperId: '',
            randomVisible: false
        }
    },
    methods: {
        handleExam2DialogClose() {
            this.$emit('closeDailog')
        },
        handleRandomDialogSubmit() {

        },
        handleTreeChange(e, checked) {
            if (!checked && this.randomOptions.id === e.id) this.randomOptions = {}
            this.randomQuestionData = this.$refs.tree.getCheckedNodes().map(val => {
                return {
                ...(val.randomOptions || this.$options.data().randomOptions),
                name: val.name,
                id: val.id,
                answerNum: val.answerNum,
                multiNum: val.multiNum,
                radioNum: val.radioNum
                }
            })
        },
        handleNodeClick(node) {
            if (!node.randomOptions) {
                node.randomOptions = {
                ...this.$options.data().randomOptions,
                name: node.name,
                id: node.id,
                answerNum: node.answerNum,
                multiNum: node.multiNum,
                radioNum: node.radioNum
                }
            }
            this.randomOptions = node.randomOptions
        },
        handleRandomDialogSubmit(cbOk) {
            if (!this.randomQuestionData.length) {
                typeof cbOk === 'function' && cbOk()
                return this.$message.error('请选择试题目录进行组卷')
            }
            const configList = this.randomQuestionData.map(val => {
                return [
                { subtype: 0, type: 0, paperGroupId: val.id, num: val.singleNumber, score: val.singleScore },
                { subtype: 1, type: 1, paperGroupId: val.id, num: val.muitibleNumber, score: val.muitibleScore },
                { subtype: 2, type: 2, paperGroupId: val.id, num: val.answerNumber, score: val.answerScore }
                ]
            })
            const options = { configList: configList.flat().filter(k => k.num) }
            this.addRandom(options)
        },
         // 加载考试
        trainExamTreeList() {
            this.$api.user.exam.trainExamTreeList().then(res => {
                this.regions = res.data
            })
        },
        // 添加随机组
        addRandom(options) {
            this.$api.user.exam.addRandom(options).then(res => {
                this.configIds = res.data.configIds
                this.$emit('confirmDailog', options.configList, this.configIds)
            })
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.trainExamTreeList()
            }
        }
    }
}
</script>
<style lang="scss">
.step-audit-dialog {
    .el-card {
        margin-bottom: .1rem;
    }
}
</style>